const DUCK_DUCK_GO_FAVICON_SERVICE = "https://icons.duckduckgo.com/ip3/";

export function getWebsiteFavicon(website?: string | null): string | null {
  if (!website) {
    return null;
  }

  const trimmedWebsite = website.trim();

  if (!trimmedWebsite) {
    return null;
  }

  try {
    const normalizedWebsite = trimmedWebsite.startsWith("http")
      ? trimmedWebsite
      : `https://${trimmedWebsite}`;

    const { hostname } = new URL(normalizedWebsite);

    if (!hostname) {
      return null;
    }

    return `${DUCK_DUCK_GO_FAVICON_SERVICE}${hostname}.ico`;
  } catch {
    return null;
  }
}
